export default [
  {
    name: 'users',
    path: '/users',
    component: () => import(/* webpackChunkName: "dfes" */ './Users')
  }
]
